import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateAssumptions } from "../../../../store/modules/waterfall/actions";
import { primary } from "../../../../assets/colorPallet";
import CurrencyFormatter from "currency-formatter";

function ReturnsSummary({
  dealType,
  assumptions,
  dispatchGenerateAssumptions,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateAssumptions(dealType);
  }, []);

  return (
    <div>
      {assumptions && (
        <div className="pt-20">

          <div className="flex items-center font-semibold text-center text-white mt-5 mb-10 pb-5">
            <div style={{ backgroundColor: primary, minWidth: "82em" }} className="absolute left-0 w-full h-20 z-10" />
            <div className="z-20" style={{ width: "18em", minWidth: "18em" }} />
            <div className="z-20 text-center px-6" style={{ width: "10em", minWidth: "10em" }}>Total Investment</div>
            <div className="z-20 text-center px-6" style={{ width: "10em", minWidth: "10em" }}>Total Proceeds</div>
            <div className="z-20 text-center px-6" style={{ width: "10em", minWidth: "10em" }}>Ownership Percentage</div>
            <div className="z-20 text-center px-6" style={{ width: "10em", minWidth: "10em" }}>Internal Rate of Return</div>
            <div className="z-20 text-center px-6" style={{ width: "10em", minWidth: "10em" }}>Equity Multiple</div>
            <div className="z-20 text-center px-1" style={{ width: "10em", minWidth: "10em" }}>Modified Internal Rate of Return</div>
          </div>

          <div className="flex items-center mt-10" >
            <div className="items-center" style={{ minWidth: "18em" }}>Limited Partners</div>
            <div className="text-center" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.LPContributionAmount, { code: "USD" })}
            </div>
            <div className="text-center" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.totalCashFlow.totalProceeds.LP, { code: "USD" })}
            </div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.LPOwnershipPercent.toFixed(2)}%</div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.IRR.LP.toFixed(2)}%</div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.EM.LP.toFixed(2)}x</div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.MIRR.toFixed(2)}%</div>
          </div>

          <div className="flex items-center mt-10" >
            <div className="items-center" style={{ minWidth: "18em" }}>Sponsor</div>
            <div className="text-center" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.GPContributionAmount, { code: "USD" })}
            </div>
            <div className="text-center" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.totalCashFlow.totalProceeds.GP, { code: "USD" })}
            </div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.GPOwnershipPercent.toFixed(2)}%</div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.IRR.GP.toFixed(2)}%</div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.EM.GP.toFixed(2)}x</div>
          </div>

          <div className="flex items-center mt-10" >
            <div className="items-center" style={{ minWidth: "18em" }}>Management</div>
            <div style={{ minWidth: "10em" }} />
            <div className="text-center" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.totalCashFlow.totalProceeds.CM, { code: "USD" })}
            </div>
            <div className="text-center" style={{ minWidth: "10em" }}>{assumptions.CMOwnershipPercent.toFixed(2)}%</div>
          </div>

          <div className="flex items-center mt-7 font-semibold">
            <div className="items-center pt-7 border-t"  style={{ minWidth: "18em" }}>Total Project</div>
            <div className="text-center pt-7 border-t" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.totalEquity, { code: "USD" })}
            </div>
            <div className="text-center pt-7 border-t" style={{ minWidth: "10em" }}>
              {CurrencyFormatter.format(assumptions.totalCashFlow.totalProceeds.total, { code: "USD" })}
            </div>
            <div className="text-center pt-7 border-t" style={{ minWidth: "10em" }}>100%</div>
            <div className="text-center pt-7 border-t" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.IRR.total.toFixed(2)}%</div>
            <div className="text-center pt-7 border-t" style={{ minWidth: "10em" }}>{assumptions.totalCashFlow.EM.total.toFixed(2)}x</div>
            <div className="text-white pt-7 border-t" style={{ minWidth: "10em" }}>&nbsp;</div>
          </div>

        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsSummary);
